import { htmlEscape } from '@edicom/common/string/htmlEscape';
import { capitalize } from '@edicom/common/case/capitalize';

export function fbScriptHelpTemplate(json, LOCALES, scope) {
  return `<div ec-layout>
    <ec-input ng-model="searchFunction" search-input icon="magnifying-glass" placeholder="${LOCALES['fbScript.search']}"></ec-input>
    
    <ewc-menu-swap ng-show="!showFunctionsList" script-menu-swap>
      ${json.Functions.Group.map(
        child =>
          child &&
          child.Function &&
          `     ${scope.functions.push(capitalize(child.attributes.name))}
                <section label="${child.attributes.name} (${child.Function.length})" icon="list">
                  ${child.Function.map(
                    child => `
                    ${scope.functions.push(capitalize(child.attributes.name))}
                    <section main-section label="${capitalize(child.attributes.name)}">
                      <div ec-flex-row>
                        <h2 ec-padding ec-margin>${capitalize(child.attributes.name)}</h2>
                        <div fake-button ec-padding declaration="${child.attributes.declaration}" title="${LOCALES['fbScript.addFunction']}" ec-border ec-border-light>
                          <ewc-icon name="plus"></ewc-icon>
                        </div>
                      </div>
                      <p ec-padding>${child.attributes.declaration}</p>
                      <pre info >${htmlEscape(child.attributes.description)}</pre><br>
                      ${!!child.Examples.Example ? `<pre ec-margin>${LOCALES['fbScript.examples']}:<br>${htmlEscape(child.Examples.Example.text)}</pre>` : ''}
                    </section>
                  `
                  ).join('')}
                </section>
              `
      ).join('')}
    </ewc-menu-swap>
    <div filter-list ng-show="showFunctionsList"></div>
  </div>`;
}
